import { Image } from "@chakra-ui/react";

import useGalleryModal from "hooks/useGalleryModal";
import { IPhoto } from "utils/offer";

type PhotoCardProps = {
  id: number;
  itemsGallery: Array<IPhoto>;
};

const getIntroById = ({ id, itemsGallery }: PhotoCardProps): IPhoto => {
  const intro = itemsGallery.find((item) => item.id === id);

  return (
    intro ?? {
      id: 0,
      path: "",
    }
  );
};

const PhotoCard = ({ id, itemsGallery }: PhotoCardProps) => {
  const { renderGalleryModal, setGalleryModalOpen } = useGalleryModal({
    media: itemsGallery,
    introPhoto: getIntroById({
      id,
      itemsGallery,
    }),
  });

  const openGallery = () => {
    setGalleryModalOpen(
      true,
      itemsGallery.findIndex((item) => item.id === id),
    );
  };

  return (
    <>
      {renderGalleryModal()}
      <Image
        flex={1}
        src={getIntroById({ id, itemsGallery }).path}
        alt="Obrázek"
        h="100%"
        w="100%"
        objectFit="cover"
        objectPosition="center"
        onClick={openGallery}
      />
    </>
  );
};
export default PhotoCard;
